import { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';

const useResponsive = () => {
  const [isClient, setIsClient] = useState(false);

  const isMobile = useMediaQuery({
    maxWidth: '690px'
  });

  const isTabletMini = useMediaQuery({
    maxWidth: '767px'
  });

  const isLaptopMini = useMediaQuery({
    minWidth: '768px'
  });

  const isTablet = useMediaQuery({
    maxWidth: '900px'
  });

  const isLaptop = useMediaQuery({
    minWidth: '691px'
  });

  const isDesktop = useMediaQuery({
    minWidth: '1024px'
  });

  useEffect(() => {
    if (typeof window !== 'undefined') setIsClient(true);
  }, []);

  return {
    isDesktop: isClient ? isDesktop : true,
    isLaptop: isClient ? isLaptop : true,
    isTablet: isClient ? isTablet : false,
    isMobile: isClient ? isMobile : false,
    isTabletMini: isClient ? isTabletMini : false,
    isLaptopMini: isClient ? isLaptopMini : false
  };
};

export default useResponsive;
